import { render, staticRenderFns } from "./access.vue?vue&type=template&id=e442471c&scoped=true"
import script from "./access.vue?vue&type=script&lang=js"
export * from "./access.vue?vue&type=script&lang=js"
import style0 from "./access.vue?vue&type=style&index=0&id=e442471c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e442471c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e442471c')) {
      api.createRecord('e442471c', component.options)
    } else {
      api.reload('e442471c', component.options)
    }
    module.hot.accept("./access.vue?vue&type=template&id=e442471c&scoped=true", function () {
      api.rerender('e442471c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/deviceAccess/access.vue"
export default component.exports